import React from 'react';
import {
    Box,
    Stack,
} from "@mui/material";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { AdminApi } from '../../api/AdminApi';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
import MainCard from "../common/MainCard/MainCard";
import { da } from 'date-fns/locale';

const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: '',
        },
    },
};

const bgColor = "#fff";
const useMockData = false;
const getMockData = () => {
    return [
        {
            "month": "2024-09",
            "participant_count": 21,
            "unique_participant_count": 4,
            "play_duration": 420
        },
        {
            "month": "2024-10",
            "participant_count": 1,
            "unique_participant_count": 1,
            "play_duration": 20
        },
        {
            "month": "2024-11",
            "participant_count": 1077,
            "unique_participant_count": 636,
            "play_duration": 21540
        },
        {
            "month": "2024-12",
            "participant_count": 554,
            "unique_participant_count": 161,
            "play_duration": 11080
        },
        {
            "month": "2025-01",
            "participant_count": 997,
            "unique_participant_count": 116,
            "play_duration": 19940
        },
        {
            "month": "2025-02",
            "participant_count": 779,
            "unique_participant_count": 89,
            "play_duration": 15580
        },
        {
            "month": "2025-03",
            "participant_count": 705,
            "unique_participant_count": 77,
            "play_duration": 21150
        },
        {
            "month": "2025-04",
            "participant_count": 645,
            "unique_participant_count": 51,
            "play_duration": 19350
        },
        {
            "month": "2025-05",
            "participant_count": 991,
            "unique_participant_count": 123,
            "play_duration": 32490
        },
        {
            "month": "2025-06",
            "participant_count": 135,
            "unique_participant_count": 19,
            "play_duration": 2850
        },
        {
            "month": "2025-07",
            "participant_count": 208,
            "unique_participant_count": 4,
            "play_duration": 6240
        },
        {
            "month": "2025-08",
            "participant_count": 0,
            "unique_participant_count": 0,
            "play_duration": 0
        }
    ];
};

const getHeading = (mode) => {
    if (mode === "participant") {
        return "參與人次/人數";
    }
    else if (mode === "play_duration") {
        return "參與時數";
    }
    return "";
}

const createChartDataFormResult = (data, mode) => {
    let lables = [];
    let dataPoints = [];

    for (let item of data) {
        lables.push(item.month);
        // dataPoints.push(item.participant_count);
    }

    let datasets = [];
    if (mode === "participant") {
        datasets = [
            {
                label: '參與人次',
                data: data.map(item => item.participant_count),
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: '參與人數',
                data: data.map(item => item.unique_participant_count),
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            }
        ];
    } else {
        datasets = [
            {
                label: '參與時數',
                data: data.map(item => item.play_duration / 60 / 60),
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            }
        ];
    }

    return {
        labels: lables,
        datasets: datasets
    }
}
// // let labels = [];
// // let participantCountData = [];
// // let uniqueParticipantCountData = [];
// // let playDurationData = [];

// // data.forEach(item => {
// //     labels.push(item.month);
// //     participantCountData.push(item.participant_count);
// //     uniqueParticipantCountData.push(item.unique_participant_count);
// //     playDurationData.push(item.play_duration);
// // }
// // );

// const chartData = {


export default function OrgMonthlyStatBarChart({ orgId, year, startMonth, mode = "participant" }) {
    const [chartData, setChartData] = React.useState(null);


    React.useEffect(() => {
        if (orgId == undefined || year == undefined || startMonth == undefined) {
            return;
        }

        loadData(orgId, year, startMonth);
    }, [orgId, year, startMonth]);




    const loadData = async (_orgId, _year, _startMonth) => {
        // load data from api
        // for now, use mock data
        if (useMockData) {
            let data = getMockData();

            let chartData = createChartDataFormResult(data, mode);
            setChartData(chartData);
            return;
        }

        AdminApi.getMonthlyParticipantDataCallback(_orgId, _year, _startMonth,
            (isSuccess, msg, result) => {
                if (isSuccess) {
                    console.debug("getMonthlyParticipantDataCallback: result=", result);
                    let chartData = createChartDataFormResult(result, mode);
                    setChartData(chartData);
                }
            });

    }
    // const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

    // let data = labels.map(() => faker.datatype.number({ min: 0, max: 1000 }));

    // const chartData = {
    //     labels,
    //     datasets: [
    //         {
    //             label: 'Dataset 1',
    //             data: data,
    //             backgroundColor: 'rgba(255, 99, 132, 0.5)',
    //         }
    //     ],
    // };
    if (chartData === null) {
        // return a loading box
        return <Box>Loading...</Box>
    }

    const heading = getHeading(mode);

    return (
        <MainCard border={false} boxShadow={true}
            contentSX={{
                p: 3, "&:last-child": { pb: 1 }
            }} sx={{ backgroundColor: bgColor, p: 0 }}>
            <Stack direction="column" justifyContent="space-between" alignItems="center"
                sx={{ mb: 2 }}>
                <Box sx={{ fontSize: '1.2rem', fontWeight: '700' }}>
                    {getHeading(mode)}
                </Box>
                <Bar options={options} data={chartData} />
            </Stack>

        </MainCard>
    )
}
